<template>
  <v-row class="pa-0 ma-0 b-BOX-GREY-DARK">
    <v-col cols="12" class="pa-0">
      <v-row align="center" style="height:25px;" class="b-B-GREY-DARK" no-gutters>
        <v-col cols="1" class="pa-0" align="center">
          <v-sheet class="pa-0 text-hidden">
            <span style="font-size: 0.625rem;">{{ yyyy }}</span>
          </v-sheet>
        </v-col>
        <v-col :cols="total ? 9 : 10">
          <v-row no-gutters>
            <v-col v-for="x in 12" :cols="1" align="center" class="pa-0" :key="x">
              <v-sheet class="pa-0 ext-hidden">
                <span style="font-size: 0.625rem;">{{ (x >= 10 ? x - 9 : x + 3) + '月' }}</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" class="pa-0" align="center">
          <v-sheet class="pa-0 text-hidden">
            <span style="font-size: 0.625rem;">{{ '平均' }}</span>
          </v-sheet>
        </v-col>
        <v-col v-if="total" cols="1" class="pa-0" align="center">
          <v-sheet class="pa-0 text-hidden">
            <span style="font-size: 0.625rem;">{{ '合計' }}</span>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" class="pa-0" align="center">
          <div class='overflow-y-auto'>
            <RecycleScroller
              class="scroller"
              :items="items"
              :item-size="16"
              key-field="key"
            >
              <template v-slot="{ item }">
                <v-sheet :color="item.color" style="height: 16px; line-height: 16px;">
                  <v-row align="center" justify="center" style="height: 16px;" no-gutters>
                    <v-col cols="1" class="pa-0 pl-1" style="line-height: 16px;" :align="item.align">
                      <span style="font-size: 0.625rem; line-height: 16px;" class="text-hidden">{{ item.title }}</span>
                    </v-col>
                    <v-col :cols="total ? 9 : 10" class="pa-0 ma-0" style="line-height: 16px;">
                      <v-row no-gutters  style="line-height: 16px;">
                        <v-col v-for="x in 12" :cols="1" class="pa-0 ma-0" :align="'end'" :key="x"  style="line-height: 16px;">
                          <span style="font-size: 0.625rem; line-height: 16px;" class="text-hidden">{{ item.prefix + item.values[x - 1] + item.suffix }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0 pr-1" :align="'end'" style="line-height: 16px;">
                      <span style="font-size: 0.625rem; line-height: 16px;" class="text-hidden">{{ item.prefix + item.sum + item.suffix }}</span>
                    </v-col>
                    <v-col v-if="total" cols="1" class="pa-0 pr-1" :align="'end'" style="line-height: 16px;">
                      <span style="font-size: 0.625rem; line-height: 16px;" class="text-hidden">{{ item.prefix + item.total + item.suffix }}</span>
                    </v-col>
                  </v-row>
                </v-sheet>
              </template>
            </RecycleScroller>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['items', 'yyyy', 'total'],
  computed: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
